@if ((done$ | async) == true) {
  <ng-container [formGroup]="itemListFormGroup" class = "question-item-list">
    <div>
      @for (question of questionItemMetaArray; track question; let i = $index) {
        @if (!question.disabled) {
          <!-- (valueFunction)="setValueFunction($event)" -->
          <app-field-item-row (valueFunction)="setValueFunction($event)" data-testid="row" [fieldMeta]="question" [formControlName]="'questionItem_' + question.question_id" ></app-field-item-row>
        }
      }
    </div>
    <div>
      <mat-divider></mat-divider>
    </div>
  </ng-container>
}